import { defineComponent as t } from "vue";
import r from "./component-library7.js";
const s = /* @__PURE__ */ t({
  __name: "product-offer-color-select",
  props: {
    offerColorVariants: { default: void 0 },
    value: { default: void 0 },
    noTitle: { type: Boolean }
  },
  emits: ["input"],
  setup(o, { emit: e }) {
    return { __sfc: !0, props: o, emits: e, ColorSelector: r };
  }
});
export {
  s as default
};
